import React, {useState, useEffect} from "react";
import './Portfolio.css'
import {ImageTitle} from '../../components/ImageTitle'
import Typography from "@mui/material/Typography";
import {Header} from "../../components/Header";
import {PortfolioCard} from "../../components/PortfolioCard";
import { useLocation } from 'react-router-dom';

interface PortfolioProps {
    imageUrl: string;
    title: string;
    path: string;
}

const Portfolio: React.FC<PortfolioProps> = ({ imageUrl, title, path }) => {
    const location = useLocation();
    const [selectedCategory, setSelectedCategory] = useState('Vida - Personas');

    useEffect(() => {
        if (location.state?.category) {
            setSelectedCategory(location.state.category);
        }
    }, [location.state]);

    const handleCategoryChange = (category: React.SetStateAction<string>) => {
        setSelectedCategory(category);
    };

    return (
        <>
            <Header variant={2}/>
            <ImageTitle imageUrl={imageUrl} title={title} path={path}/>

            <div>

                <div className="portfolio-title">
                    <Typography
                        sx={{
                            color: '#ff6c00',
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '20px',
                            fontWeight: 500,
                            marginBottom: '15px'
                        }}
                    >
                        Protección hecha a tu medida
                    </Typography>
                    <Typography
                        sx={{
                            color: '#3b3b3b',
                            fontFamily: "Inter, sans-serif",
                            fontSize: '44px',
                            fontWeight: 700,
                            marginBottom: '20px',
                            lineHeight: '1.2em',
                        }}
                    >
                        Conoce todas las soluciones
                        <br/>
                        que tenemos para ti
                    </Typography>
                </div>

                <div className="navigation-options">
                    <button className="cta" onClick={() => handleCategoryChange('Vida - Personas')}>
                        <span className="hover-underline-animation"> Vida - Personas </span>
                    </button>
                    <button className="cta" onClick={() => handleCategoryChange('Vehículos, transporte y logística')}>
                        <span className="hover-underline-animation"> Vehículos, transporte y logística </span>
                    </button>
                    <button className="cta" onClick={() => handleCategoryChange('Otros productos')}>
                        <span className="hover-underline-animation"> Otros productos </span>
                    </button>
                </div>

                {selectedCategory === 'Vida - Personas' && (
                    <div id="Vida - Personas" style={{ marginBottom: '150px' }} >
                        <div className="card-container">
                            <PortfolioCard imageUrl={"/Assets/seguro-estudiantil.jpg"} title={"Vida - Personas"} path={"Seguro educativo"} forward={"Seguro-educativo"}/>
                            <PortfolioCard imageUrl={"/Assets/seguro-hogar.jpeg"} title={"Vida - Personas"} path={"Seguro de hogar"} forward={"Seguro-de-hogar"}/>
                            <PortfolioCard imageUrl={"/Assets/seguro-mascotas.jpg"} title={"Vida - Personas"} path={"Seguro de mascotas"} forward={"Seguro-de-mascotas"}/>
                            <PortfolioCard imageUrl={"/Assets/vida.jpeg"} title={"Vida - Personas"} path={"Vida individual"} forward={"Vida-individual"}/>
                            <PortfolioCard imageUrl={"/Assets/grupo.jpeg"} title={"Vida - Personas"} path={"Vida grupo"} forward={"Vida-grupo"}/>
                            <PortfolioCard imageUrl={"/Assets/deudor.jpeg"} title={"Vida - Personas"} path={"Vida deudor"} forward={"Vida-deudor"}/>
                            <PortfolioCard imageUrl={"/Assets/salud.jpeg"} title={"Vida - Personas"} path={"Seguro de salud"} forward={"Seguro-de-salud"}/>
                            <PortfolioCard imageUrl={"/Assets/arl.jpg"} title={"Vida - Personas"} path={"ARL"} forward={"Arl"}/>
                        </div>
                    </div>
                )}

                {selectedCategory === 'Vehículos, transporte y logística' && (
                    <div id="Vehículos, transporte y logística" style={{ marginBottom: '150px' }} >
                        <div className="card-container">
                            <PortfolioCard imageUrl={"/Assets/carga.jpeg"} title={"Vehículos y transporte"} path={"Transporte de carga"} forward={"Transporte-de-carga"}/>
                            <PortfolioCard imageUrl={"/Assets/pesados.jpeg"} title={"Patrimoniales"} path={"Todo riesgo pesados"} forward={"Todo-riesgo-pesados"}/>
                            <PortfolioCard imageUrl={"/Assets/livianos4.jpeg"} title={"Patrimoniales"} path={"Todo riesgo livianos"} forward={"Todo-riesgo-livianos"}/>
                            <PortfolioCard imageUrl={"/Assets/construccion.jpeg"} title={"Empresariales"} path={"Todo riesgo construcción"} forward={"Todo-riesgo-construccion"}/>
                            <PortfolioCard imageUrl={"/Assets/hidrocarburos.jpeg"} title={"Empresariales"} path={"Hidrocarburos"} forward={"Hidrocarburos"}/>
                            <PortfolioCard imageUrl={"/Assets/maquinaria-amarilla.jpeg"} title={"Patrimoniales"} path={"Maquinaria amarilla"} forward={"Maquinaria-amarilla"}/>
                            <PortfolioCard imageUrl={"/Assets/Products7.jpeg"} title={"Empresariales"} path={"R.C. Contractual"} forward={"Rc-contra"}/>
                            <PortfolioCard imageUrl={"/Assets/products.jpeg"} title={"Empresariales"} path={"R.C. Extracontractual"} forward={"Rc-extra"}/>
                            <PortfolioCard imageUrl={"/Assets/pil.jpeg"} title={"Empresariales"} path={"PIL"} forward={"Pil"}/>
                            <PortfolioCard imageUrl={"/Assets/plo.jpeg"} title={"Empresariales"} path={"PLO"} forward={"Plo"}/>
                        </div>
                    </div>
                )}

                {selectedCategory === 'Otros productos' && (
                    <div id="Otros productos" style={{ marginBottom: '150px' }}>
                        <div className="card-container">
                            <PortfolioCard imageUrl={"/Assets/arrendamiento.jpg"} title={"Otros productos"} path={"Seguro de arrendamiento"} forward={"Seguro-de-arrendamiento"}/>
                            <PortfolioCard imageUrl={"/Assets/cumplimiento.jpg"} title={"Otros productos"} path={"Cumplimiento"} forward={"Cumplimiento"}/>
                            <PortfolioCard imageUrl={"/Assets/areas-comunes1.jpg"} title={"Otros productos"} path={"Áreas comunes"} forward={"Areas-comunes"}/>
                            <PortfolioCard imageUrl={"/Assets/pymes.jpg"} title={"Otros productos"} path={"Pymes"} forward={"Pymes"}/>
                        </div>
                    </div>
                )}
            </div>

        </>
    )
}

export default Portfolio;